import { useList, useDetail, useCreate, useUpdate, useDelete, useListInfinite, useAction } from "@inmagik/react-crud"
import { Documento, HistoricalInfo } from "../types"
import { API_URL } from "../constants"

export function useDocumentiList(params: Record<string, string | number | string[] | number[]> = {}) {
  return useList<Documento>(`${API_URL}/documenti`, {
    query: params,
  })
}

export function useDocumento(id: number | undefined | string) {
  return useDetail<Documento>(`${API_URL}/documenti`, id?.toString())
}

export function useDocumentoCreate() {
  return useCreate<Documento>(`${API_URL}/documenti`)
}

export function useDocumentoUpdate() {
  return useUpdate<Documento>(`${API_URL}/documenti`)
}

export function useDocumentoDelete() {
  return useDelete<Documento>(`${API_URL}/documenti`)
}

export function useDocumentoHistory(id: number | string) {
  return useListInfinite<HistoricalInfo>(`${API_URL}/documenti/${id}/history`)
}

export function useDocumentoSetResponsabili(id: number | string) {
  return useAction(`${API_URL}/documenti/${id}/set-responsabili`, {
    method: "POST",
  })
}

export function useDownloadDocumenti(params: Record<string, string | number | string[] | number[]> = {}) {
  return useAction<Blob, void>(`${API_URL}/documenti/download`, {
    method: "GET",
    query: params,
    responseType: "blob",
  })
}

